import gql from 'graphql-tag';
import useGraphQLClient from 'hooks/graphql/useGraphQLClient/useGraphQLClient';
import { useCallback } from 'react';
import { MemberClockStateQuery } from '__generated__/graphql';

export const MEMBER_CLOCK_STATE_QUERY = gql`
  query MemberClockState {
    memberClockState {
      clockedIn
      clockedOut
      onBreak
    }
  }
`;

export default function useMemberClockState() {
  const client = useGraphQLClient();
  return useCallback(() => {
    return client.request<MemberClockStateQuery>(MEMBER_CLOCK_STATE_QUERY);
  }, [client]);
}
